import AuthTransition from "./AuthTransition.vue"
import ChatTransition from "./ChatTransition.vue"
export default {
    AuthTransition, ChatTransition
}